import React, { useState } from "react";
import { C, RFLogo } from "../theme";
import { fmtD, getAppCopy } from "../shared";
import { IMMEUBLES } from "../data";

export const Sidebar = ({ page, setPage, onLogout, immId, setImmId, pendingCount = 0, locale = "fr", notifs = [], setNotifs = () => {}, maintUrgent = 0 }) => {
  const copy = getAppCopy(locale);
  const [showNotifs, setShowNotifs] = useState(false);
  const unread = notifs.filter(n => !n.lu).length;
  const nav = [
    {id:"dashboard",  icon:"📊", label:copy.dashboard},
    {id:"residents",  icon:"👥", label:copy.residents},
    {id:"cotisations",icon:"💰", label:copy.cotisations},
    {id:"factures",   icon:"🧾", label:copy.billing},
    {id:"charges",    icon:"💸", label:copy.charges},
    {id:"travaux",    icon:"🔧", label:copy.works},
    {id:"maintenance",icon:"🛠️", label:"Maintenance", urgent:true},
    {id:"employes",   icon:"👷", label:"Employés"},
    {id:"documents",  icon:"📁", label:"Documents"},
    {id:"ag",         icon:"🗳️", label:copy.assemblies},
    {id:"marketplace",icon:"🏪", label:copy.marketplace, badge:true},
    {id:"rapports",   icon:"📄", label:copy.reports},
  ];
  const notifIcon = {relance:"📧", paiement:"✅", inscription:"👤", prestataire:"🔧", retard:"⚠️"};

  return (
  <div style={{width:238,background:C.navy,height:"100vh",position:"fixed",left:0,top:0,display:"flex",flexDirection:"column",zIndex:50,borderRight:"1px solid rgba(255,255,255,.05)"}}>
    <div style={{padding:"22px 18px 14px"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <RFLogo size={34} />
          <div>
            <p style={{fontFamily:"Syne",fontWeight:800,color:"#fff",fontSize:16,lineHeight:1}}>RésiFlow</p>
            <p style={{color:"rgba(255,255,255,.35)",fontSize:10,marginTop:2}}>{copy.syndicSpace}</p>
          </div>
        </div>
        {/* Notification Bell */}
        <div style={{position:"relative"}}>
          <button className="btn" onClick={() => { setShowNotifs(!showNotifs); if(!showNotifs) setNotifs(n => n.map(x => ({...x, lu:true}))); }}
            style={{width:34,height:34,borderRadius:10,background:"rgba(255,255,255,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,color:"#fff",border:"none"}}>
            🔔
          </button>
          {unread > 0 && (
            <span className="notif-dot" style={{position:"absolute",top:-3,right:-3,background:C.red,color:"#fff",borderRadius:"50%",width:16,height:16,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700,border:"2px solid #0b1333"}}>
              {unread}
            </span>
          )}
          {showNotifs && (
            <div style={{position:"fixed",left:248,top:10,width:320,background:"#fff",borderRadius:16,boxShadow:"0 8px 40px rgba(11,19,51,.18)",zIndex:300,overflow:"hidden",animation:"fadeUp .2s ease"}}>
              <div style={{padding:"14px 18px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <p style={{fontWeight:700,fontSize:14,color:C.text,fontFamily:"Syne"}}>Notifications</p>
                <span style={{fontSize:11,color:C.muted}}>{notifs.length} au total</span>
              </div>
              {notifs.map(n => (
                <div key={n.id} style={{padding:"11px 18px",borderBottom:`1px solid ${C.border}`,background:n.lu?"#fff":"#f8f9ff",display:"flex",gap:10,alignItems:"flex-start"}}>
                  <span style={{fontSize:16,marginTop:1}}>{notifIcon[n.type] || "📌"}</span>
                  <div style={{flex:1}}>
                    <p style={{fontSize:13,color:C.text,fontWeight:n.lu?400:600,lineHeight:1.4}}>{n.msg}</p>
                    <p style={{fontSize:11,color:C.muted,marginTop:3}}>{fmtD(n.date)}</p>
                  </div>
                  {!n.lu && <div style={{width:7,height:7,borderRadius:"50%",background:C.blue,marginTop:5,flexShrink:0}} />}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div style={{background:"rgba(255,255,255,.07)",borderRadius:10,padding:"8px 10px"}}>
        <p style={{fontSize:10,fontWeight:700,color:"rgba(255,255,255,.35)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>{copy.activeResidence}</p>
        <select value={immId} onChange={e => setImmId(Number(e.target.value))}
          style={{width:"100%",background:"transparent",border:"none",color:"#fff",fontFamily:"DM Sans",fontWeight:600,fontSize:13,outline:"none",cursor:"pointer"}}>
          {IMMEUBLES.map(i => <option key={i.id} value={i.id} style={{background:C.navy}}>{i.nom}</option>)}
        </select>
        <p style={{fontSize:10,color:"rgba(255,255,255,.3)",marginTop:3}}>{IMMEUBLES.find(i => i.id === immId)?.adresse}</p>
      </div>
    </div>
    <nav style={{flex:1,padding:"0 8px",overflowY:"auto"}}>
      {nav.map(n => (
        <div key={n.id} className="ni" onClick={() => { setPage(n.id); setShowNotifs(false); }}
          style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:11,marginBottom:2,cursor:"pointer",
            background:page===n.id?`${C.teal}22`:"transparent",
            borderLeft:page===n.id?`3px solid ${C.teal}`:"3px solid transparent"}}>
          <span style={{fontSize:17}}>{n.icon}</span>
          <span style={{fontSize:13,fontWeight:600,color:page===n.id?"#fff":"rgba(255,255,255,.5)",flex:1}}>{n.label}</span>
          {n.id==="residents" && pendingCount>0 && <span style={{background:C.red,color:"#fff",borderRadius:"50%",width:18,height:18,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700}}>{pendingCount}</span>}
          {n.id==="maintenance" && maintUrgent>0 && <span style={{background:C.red,color:"#fff",borderRadius:"50%",width:18,height:18,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700}}>{maintUrgent}</span>}
          {n.badge && <span style={{background:`linear-gradient(135deg,${C.teal},${C.blue})`,color:"#fff",fontSize:10,fontWeight:700,padding:"1px 7px",borderRadius:20}}>NEW</span>}
        </div>
      ))}
    </nav>
    <div style={{padding:"12px 18px",borderTop:"1px solid rgba(255,255,255,.08)"}}>
      <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:10}}>
        <div style={{width:32,height:32,borderRadius:"50%",background:`linear-gradient(135deg,${C.teal},${C.blue})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:13,fontWeight:700}}>AS</div>
        <div>
          <p style={{color:"#fff",fontSize:12,fontWeight:600}}>Ahmed Syndic</p>
          <p style={{color:"rgba(255,255,255,.3)",fontSize:10}}>{copy.admin}</p>
        </div>
      </div>
      <button className="btn" onClick={onLogout}
        style={{width:"100%",padding:"7px",borderRadius:9,border:"1px solid rgba(255,255,255,.15)",background:"transparent",color:"rgba(255,255,255,.45)",fontSize:12,fontWeight:600}}>
        {copy.logout}
      </button>
      <p style={{textAlign:"center",fontSize:9,color:"rgba(255,255,255,.2)",marginTop:8,letterSpacing:".3px"}}>RésiFlow · resiflow.ma</p>
    </div>
  </div>
);
};

/* ══════════════════════════════════════
   SYNDIC — DASHBOARD
══════════════════════════════════════ */
